import type { Setting, User } from "@/types"
import { Store } from "@tanstack/store"

export interface UserStore {
 token: string | null
 refresh_token: string | null
 user: User | null
 isLoggedIn: boolean
 balance: number
 points: number
 takenValues: number
 profit: number
 two_step?:boolean,
 today_points: number,
 setting: Setting | null,
 profile: {
  store_name?: string
 }
 }

export const STORAGE_KEY = "user-store"

function loadInitialState(): UserStore {
 try {
   const stored = localStorage.getItem(STORAGE_KEY)
   if (stored) return JSON.parse(stored)
 } catch {}
 return {
   token: null,
   refresh_token: null,
   user: null,
   isLoggedIn: false,
   balance: 0,
   points: 0,
   takenValues: 0,
   today_points: 0,
   profit: 0,
   two_step: false,
   setting: null,
   profile: {}
 }
}

const userStore = new Store<UserStore>(loadInitialState())

/**
 * وضعیت «تایید پروفایل»:
 * - کاربرانی که نوعشان غیر از ordinary است (panel/webservice/admin/esaj) تاییدشده محسوب می‌شوند.
 * - کاربر ordinary وقتی تاییدشده است که profile_confirm مقدار معتبر داشته باشد.
 *   API بسته به endpoint این مقدار را به‌صورت true، 1 یا تاریخ تایید برمی‌گرداند.
 */
export const isProfileConfirmed = (user?: User | null): boolean => {
  if (!user) return false
  if (user.type && user.type !== "ordinary") return true

  const confirmation = user.profile_confirm
  return ![undefined, null, false, 0, "0", ""].includes(confirmation)
}

userStore.subscribe((state) => {
 try {
   localStorage.setItem(STORAGE_KEY, JSON.stringify(state.currentVal))
 } catch {}
})

export default userStore
